<template>
  <div>
    <portal to="toolbar-title"> Αιτήματα</portal>
    <portal to="toolbar-actions">
    </portal>
    <v-row class="white" no-gutters>
      <v-col lg="4" style="border-right: 1px  #e3e3e3 solid;">
        <v-card color="transparent" min-height="80vh" flat>
          <v-toolbar dense flat>
            <v-toolbar-title style="font-weight: bolder; font-size: 1.5em;"> Αιτήματα</v-toolbar-title>
            <v-spacer>
            </v-spacer>
            <v-btn color="primary" text to="/addIssue">
              <v-icon>mdi-plus</v-icon>
              NEO ΑΙΤΗΜΑ
            </v-btn>
            <filters-modal module-name="IssueHandler"></filters-modal>
          </v-toolbar>
          <v-tabs height="40" @change="onModeChange">
            <v-tab> ΑΝΟΙΧΤΑ</v-tab>
            <v-tab> ΚΛΕΙΣΤΑ</v-tab>
            <v-tab-item>
              <v-list max-height="70vh" class="overflow-y-auto">
                <v-list-item v-if="data.length === 0 ">
                  <v-list-item-content>
                    Δεν έχουν δημιουργηθεί αιτήματα ακόμα.
                  </v-list-item-content>
                </v-list-item>
                <v-list-item-group class="pa-2" v-model="activeIndex">
                  <issue-item @click="setIssue(i)" v-for="i in data" :item="i"/>
                </v-list-item-group>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-list max-height="70vh" class="overflow-y-auto">
                <v-list-item v-if="closedIssuesData.length === 0 ">
                  <v-list-item-content>
                    Δεν υπάρχουν κλειστά αιτήματα
                  </v-list-item-content>
                </v-list-item>
                <v-list-item-group class="pa-2" v-model="activeIndex">
                  <issue-item @click="setIssue(i)" v-for="i in closedIssuesData" :item="i"/>
                </v-list-item-group>
              </v-list>

            </v-tab-item>
          </v-tabs>

        </v-card>
      </v-col>
      <v-col lg="8" class="white">
        <issue-chat @issueClosed="onIssueClosed()" v-if="issue" :issue="issue"/>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import IssueItem from "../components/IssueListItem";
import IssueChat from "../components/IssueChat";
import Filters from "../../../wl-datagrid-handler/Filters";
import issueMixin from "@/views/Issues/mixins/issueMixin";
import FiltersModal from "@/wl-datagrid-handler/FiltersModal";

export default {
  name: "IssuesDesktop",
  components: {FiltersModal, Filters, IssueChat, IssueItem},
  mixins: [issueMixin],
  methods: {
    onModeChange(tab) {
      this.activeIndex = 0;
      if (tab === 1) {
        this.getClosedIssues();
        this.setClosedIssues();
        this.resetSelectedClosedIssue();
      } else {
        this.resetSelectedOpenIssue()
      }
    },
    onIssueClosed() {
      this.resetSelectedOpenIssue();
    }
  }
}
</script>

<style scoped>

</style>
